export function isAuthenticated() {
    return !(sessionStorage.getItem('token') === undefined || sessionStorage.getItem('token') === null);
}
export function isAdmin(){
    return sessionStorage.getItem("Role") == 10 || sessionStorage.getItem("Role") == 20;
}